import './header.scss'

/* FontAwesome */
//import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome'
//import { faCogs } from '@fortawesome/free-solid-svg-icons'

/* Bootstrap */
import Navbar from 'react-bootstrap/Navbar'

import MenuItems from './MenuItems'

const Header:React.FC = () => <header className='App-header' data-testid='App-Header'>

  <Navbar bg='dark' variant='dark' expand='md'>

    <Navbar.Toggle />

    <Navbar.Collapse>
      <MenuItems />
    </Navbar.Collapse>

    <Navbar>

    </Navbar>

  </Navbar>
  
</header>

export default Header